import {useDataProvider} from "./base-data.provider";
import {useCallback} from "react";

export function useQuizAssessmentQuestionBankDataProvider(callback, deps) {
  const { request } = useDataProvider();

  const listBanks  = useCallback(() => {
    return request({
      method: "GET",
      path: "/quiz-assessment-question-bank",
    })
  }, [request]);

  const finQuestionBank = useCallback((id) => {
    return request({
      method: "GET",
      path: `/quiz-assessment-question-bank/${id}`,
    });
  }, [request])

  return {
    listBanks,
    finQuestionBank
  }
}
